<template>
  <el-drawer title="编辑工单" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="editForm" status-icon :model="editForm" label-width="83px" label-position="left" size="small" class="mx-20-4 bg-#fff py-20 pr-30" :rules="rules">
      <div class="form-Title">报修人信息</div>
      <el-form-item label="所属项目：" prop="communityId">
        <el-select v-model="editForm.communityId" filterable clearable placeholder="选择所属项目" @change="communityChange" style="width: 100%">
          <el-option v-for="item in searchCommunities" :key="item.communityId" :label="item.communityName" :value="item.communityId" />
        </el-select>
      </el-form-item>
      <el-form-item label="房屋编号：" prop="buildingRoomCode">
        <el-select
          v-model="editForm.buildingRoomCode"
          filterable
          remote
          clearable
          :remote-method="remoteMethod"
          value-key="buildingRoomId"
          :disabled="!editForm.communityId"
          placeholder="填写两位数以上的房屋编号"
          style="width: 100%"
        >
          <el-option
            v-for="item in indexThis.buildingRoomListArr"
            :key="item.buildingRoomId"
            :label="item.buildingRoomCode"
            :value="{ buildingRoomCode: item.buildingRoomCode, buildingRoomId: item.buildingRoomId }"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="报修人：" prop="submitUserName">
        <el-input v-angle="editForm.submitUserName" v-model="editForm.submitUserName" placeholder="填写报修人" clearable />
      </el-form-item>
      <el-form-item label="联系方式：" prop="submitUserPhone">
        <el-input v-angle="editForm.submitUserPhone" v-model="editForm.submitUserPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable />
      </el-form-item>
      <div class="form-Title">工单信息</div>
      <el-form-item label="工单分类：" prop="categoryId">
        <el-cascader
          ref="cascader"
          :key="keyValue"
          v-model="editForm.categoryId"
          :disabled="!editForm.communityId"
          placeholder="选择工单分类"
          :options="indexThis.worksheetCategoryListArr"
          :props="{ expandTrigger: 'click' }"
          @change="change"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="报修内容：" prop="content">
        <el-input v-angle="editForm.content" v-model="editForm.content" type="textarea" :rows="4" placeholder="填写报修内容" />
      </el-form-item>
      <el-form-item label="报修情况：" prop="urgentType">
        <el-radio-group v-model="editForm.urgentType">
          <el-radio :label="1">紧急</el-radio>
          <el-radio :label="2">重要</el-radio>
          <el-radio :label="3">一般</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预约时间：" prop="appointmentTime" label-width="73px" style="margin-left: 10px">
        <el-date-picker v-model="editForm.appointmentTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择预约时间" style="width: 100%" />
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { cloneDeep } from 'lodash'
import { worksheetUpd } from '@/api/workOrder'
import formatRequestData from '@/utils/formatRequestData'
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      editForm: {},
      rules: {
        communityId: [{ required: true, message: '所属项目不能为空', trigger: 'change' }],
        submitUserPhone: [
          { required: true, message: '报修人电话不能为空', trigger: 'change' },
          {
            required: true,
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '电话格式不正确',
            trigger: 'change',
          },
        ],
        submitUserName: [{ required: true, message: '报修人不能为空', trigger: 'change' }],
        buildingRoomCode: [{ required: true, message: '房屋编号不能为空', trigger: 'change' }],
        categoryId: [{ required: true, message: '工单分类不能为空', trigger: 'change' }],
        content: [{ required: true, message: '报修内容不能为空', trigger: 'change' }],
        urgentType: [{ required: true, message: '报修情况不能为空', trigger: 'change' }],
      },
      cloneFormData: {},
      keyValue: 0,
    }
  },
  watch: {
    'indexThis.worksheetCategoryListArr': {
      deep: true,
      handler() {
        this.keyValue++
      },
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.editForm.validate().catch(() => {})
      if (!valid) return false
      const submitFormData = this.diffEditForm(this.editForm, this.cloneFormData)
      if (this.judgeObjISEmpty(submitFormData)) return (this.drawer = false)
      if (submitFormData.categoryId) submitFormData.categoryId = submitFormData.categoryId[1]
      const { data: res } = await worksheetUpd({
        id: this.editForm.id,
        ...formatRequestData(submitFormData),
      })
      if (!res) return this.$message.error('编辑失败')
      this.$message.success('编辑成功')
      this.indexThis.$refs.Drawer.$refs.CardWorkList.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.editForm.resetFields()
    },
    communityChange(e) {
      this.editForm.buildingRoomId = ''
      this.editForm.buildingRoomCode = ''
      if (!e) return
      this.indexThis.worksheetCategoryList({
        communityId: e,
        filterMissRule: true,
      })
    },
    remoteMethod(e) {
      if (e.length < 2) return
      this.indexThis.buildingRoomList({
        queryValue: e,
        communityId: this.editForm.communityId,
      })
    },
    change() {
      this.editForm.categoryName = this.$refs.cascader.getCheckedNodes()[0].label
    },

    init() {
      this.editForm.categoryId = [this.editForm.worksheetType, this.editForm.categoryId]
      this.editForm.buildingRoomId = {
        buildingRoomId: this.editForm.buildingRoomId,
        buildingRoomCode: this.editForm.buildingRoomCode,
      }
      this.cloneFormData = cloneDeep(this.editForm)
    },
  },
}
</script>
